import { Module } from "vuex";

import { RootState } from "@/types";

export interface AppState {
  drawer: boolean;
}

export const app: Module<AppState, RootState> = {
  state: {
    drawer: false,
  },
  mutations: {
    setDrawer(state, token: boolean) {
      state.drawer = token;
    },
  },
  actions: {},
  getters: {
    drawer: (state) => state.drawer,
  },
};
